import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class AffiliateConfigService {
	constructor(private config: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getAffiliatesEndpoint(): string {
		return this.config.get((x) => x.common.affiliate.endpoints!.affiliates, "v1/affiliates");
	}

	isDisabled(): boolean {
		return this.config.get((x) => x.common.affiliate.disabled, false);
	}

	cookieExpiryInDays(): number {
		return this.config.get((x) => x.common.affiliate.cookieExpiryInDays, 30);
	}

	/**
	 * @deprecated [fabric-deprecated] - Use document.obgEventBus.retrieve(AccountAppValue.GetAffiliateData) instead.
	 */
	tokenCookieName(): string {
		return this.config.get((x) => x.common.affiliate.tokenCookieName, "token");
	}

	/**
	 * @deprecated [fabric-deprecated] - Use document.obgEventBus.retrieve(AccountAppValue.GetAffiliateData) instead.
	 */
	codeCookieName(): string {
		return this.config.get((x) => x.common.affiliate.codeCookieName, "affcode");
	}

	/**
	 * @deprecated [fabric-deprecated] - Use document.obgEventBus.retrieve(AccountAppValue.GetAffiliateData) instead.
	 */
	partnerIdCookieName(): string {
		return this.config.get((x) => x.common.affiliate.partnerIdCookieName, "PartnerId");
	}

	tokenQueryStringName(): string {
		return this.config.get((x) => x.common.affiliate.tokenQueryStringName, "token");
	}

	codeQueryStringName(): string {
		return this.config.get((x) => x.common.affiliate.codeQueryStringName, "affcode");
	}

	fromQueryStringName(): string {
		return this.config.get((x) => x.common.affiliate.fromQueryStringName, "from");
	}
}
